exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".processinitiativepage-cssmodule-processinitiativepage-component-2DrJ2{border:1px dashed red;border:none}.processinitiativepage-cssmodule-form-container-3Z91c{margin-top:10px}", ""]);

// exports
exports.locals = {
	"processinitiativepage-component": "processinitiativepage-cssmodule-processinitiativepage-component-2DrJ2",
	"form-container": "processinitiativepage-cssmodule-form-container-3Z91c"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/ProcessIdeas/processinitiativepage.cssmodule.scss
// module id = 608
// module chunks = 0